import Vue from 'vue';
import { status } from '@/services/AxiosService';
import store from '@/store';
const { $gettext } = Vue.prototype;
export default {
  getTitle(message) {
    if(message.code == status.HTTP_NOT_FOUND) {
      return $gettext('Record not found');
    }
    if(message.code == status.HTTP_BAD_REQUEST) {
      return $gettext('Invalid request');
    }
    if(message.code == status.HTTP_INTERNAL_SERVER_ERROR) {
      return $gettext('Unable to process request');
    }
    if(message.action) {
      // convert camelCase and snake_case to normal case
      const action = message.action.split('_').join(' ').toLowerCase();
      return $gettext('Unable to') + ' ' + $gettext(action);
    }
  },
  getContent(message) {
    if(message.code) {
      if(message.code == status.HTTP_NOT_FOUND) {
        return this.entityNotFound(message);
      }
      if (message.code == status.HTTP_BAD_REQUEST) {
        return this.badRequest(message);
      }
      if(message.code == status.HTTP_FORBIDDEN) {
        return this.forbidden(message);
      }
      if(message.code == status.HTTP_UNAUTHORIZED) {
        return this.forbidden(message);
      }
      if(message.code == status.HTTP_INTERNAL_SERVER_ERROR) {
        return this.serverError(message);
      }
    }
    return message;
  },
  inlineError(response) {
    if (response.code == status.HTTP_BAD_REQUEST) {
      const errors = [];
      if(Array.isArray(response.error)) {
        response.error.forEach(error => {
          errors.push({
            field: error.field,
            msg: $gettext(error.error),
          });
        });
        return errors;
      }
      return [{msg: response.error, field: response.field}];
    }
  },
  entityNotFound(message) {
    return $gettext(message.entity) 
            + ' #' + message.id 
            + ' ' + $gettext('does not exist or deleted');
  },
  badRequest(message) {
    if(message.field && message.field == 'staff') {
      return $gettext(message.field) 
            + ' #' + message.value + ' ' + $gettext(message.error) ;
    }
    if(message.shifts) {
      let shifts = '<br>';
      message.shifts.forEach(shift => {
        shifts += $gettext('Shift') + ' ' + shift.name 
                    + ' - ' + shift.station 
                    + ' - ' + shift.user 
                    + '<br>';  
      })
      return $gettext(message.error) + shifts;
    }
    if(Array.isArray(message.error)) {
      return message.error.map(e => {
        if(e.field == 'product') {
          const product = store.getters.getObject(e.value, 'articles');
          return `Product ${product.name} was deleted`;
        }
        return `${e.error} ${e.field} ${e.value}`;
      }).join('<br>');
    }
    return $gettext(message.error) 
            + (message.id ? (' #' + message.id) : '');
  },
  forbidden(message) {
    return $gettext(message.error);
  },
  serverError(message) {
    if(message.error == 'The optimistic lock on an entity failed.'
        || message.error.indexOf('Deadlock found when trying to get lock; try restarting transaction') != -1
    ) {
      return $gettext('Server is busy at the moment. Please try again');
    } else if(message.error.search('Failed to print') != -1){
      return $gettext('Printer connection failed');
    } else if(message.error == 'Network Error') {
      return $gettext(message.error);
    }    
    return $gettext('Sorry, something went wrong on our end. We are notified about this and currently trying to fix the problem.');
  }
};
